import styled from '@emotion/styled';
import { commonColors } from 'application/theme';

interface DropdownStyledProps {
  isActive?: boolean;
  disabled?: boolean;
  isError?: boolean;
}

interface OptionItemProps {
  selected: boolean;
  isMulti?: boolean;
  isHidden?: boolean;
}

interface ErrorProps {
  isError?: boolean;
}

export const Wrapper = styled.div<ErrorProps>`
  display: grid;
  gap: 6px;
  > label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.08px;
    color: ${({ isError }) =>
      isError ? commonColors.error2 : commonColors.grey600};
  }

  > span {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.07px;
    color: ${commonColors.error2};
  }
`;

export const DropdownStyled = styled.div<DropdownStyledProps>`
  display: grid;
  gap: 6px;
  width: 100%;
  position: relative;

  > label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.08px;
    color: ${({ disabled }) =>
      disabled ? commonColors.grey400 : commonColors.grey600};
  }

  > span {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.07px;
    color: ${({ disabled }) =>
      disabled ? commonColors.grey400 : commonColors.grey600};
  }
  > section {
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    width: 100%;
    height: 44px;
    background: ${({ isActive, disabled, isError }) =>
      isError
        ? commonColors.error3
        : isActive
        ? commonColors.blue50
        : commonColors[disabled ? 'grey50' : 'white']};
    border: 1px solid
      ${({ isActive, isError }) =>
        isError
          ? commonColors.error2
          : isActive
          ? commonColors.blue800
          : commonColors.grey300};
    box-shadow: 1px 1px 2px rgba(16, 24, 40, 0.12);
    border-radius: 8px;
    outline: none;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.005em;
    color: ${commonColors.grey700};
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    white-space: nowrap;

    > span {
      color: ${({ disabled }) =>
        disabled ? commonColors.grey300 : commonColors.grey500};
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    > svg {
      margin-left: 12px;
      transform: ${({ isActive }) => (isActive ? 'rotate(180deg)' : '')};
      path {
        fill: ${({ disabled }) =>
          disabled ? commonColors.grey300 : commonColors.grey700};
      }
    }

    > h2 {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
`;

export const OptionsList = styled.div`
  display: grid;
  padding: 12px;
  gap: 4px;
  grid-template-rows: max-content;
  position: absolute;
  z-index: 10;
  top: 44px;
  max-height: 390px;
  min-width: 440px;
  overflow-y: auto;
  width: 100%;
  border-radius: 8px;
  background: ${commonColors.white};
  box-shadow: 0 10px 45px 0 rgba(14, 40, 83, 0.07);
  cursor: pointer;
`;

export const OptionCheckBox = styled.label<OptionItemProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-radius: 4px;
  cursor: ${({ isHidden }) => (isHidden ? 'default' : 'pointer')};
  background: ${({ selected }) =>
    selected ? commonColors.blue100 : 'transparent'};

  opacity: ${({ isHidden }) => (isHidden ? 0.6 : 1)};
  pointer-events: ${({ isHidden }) => (isHidden ? 'none' : 'all')};

  &:hover {
    background: ${commonColors.grey100};
  }

  > div:first-child {
    display: flex;
    align-items: center;
  }

  > p {
    color: ${commonColors.grey800};
    font-size: 16px;
    font-weight: 500;
    line-height: 22.4px;
    letter-spacing: 0.08px;
  }

  > div:first-child {
    margin-right: 12px;
    label {
      padding: 0px;
    }
  }
  > div:last-child {
    display: ${({ isMulti }) => (!isMulti ? 'none' : 'flex')};
  }
`;

export const ClinicImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  background: ${commonColors.blueDark100};
  margin-right: 16px;
  color: ${commonColors.white};

  > svg {
    path {
      fill: ${commonColors.grey900};
    }
  }

  > img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
`;
